/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import DayPicker from 'react-day-picker';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import dateArray from 'moment-array-dates';

import RoleCardMultipleButton from '../MultipleButton';
import { toggleOptionCard } from '../../../../actions/ViewController';
import { updateField } from '../../../../actions/BookingRequest';
import { getTime } from '../../../../api/DataHandlers';
import NumberOfWorkersSpinner from '../numberofworkersspinner';
import { DATE_FORMAT, TIME_FORMAT, jobModes } from '../../../../consts';

class AgentTimeDateCard extends Component {
    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleDayMouseDown = this.handleDayMouseDown.bind(this);
        this.handleDayMouseUp = this.handleDayMouseUp.bind(this);
        this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
        this.onStartChange = this.onStartChange.bind(this);
        this.onEndChange = this.onEndChange.bind(this);
        this.toggleAllowMonthChange = this.toggleAllowMonthChange.bind(this);
        this.breaksInput = React.createRef(null);
        this.daypickerRef = React.createRef(null);

        this.state = {
            mouseDown: false,
            fromDate: null,
            allowMonthChange: true,
        };
    }

    componentDidMount() {
        this.breaksInput.current.value = null;
    }

    checkDateTimeValid(date, time) {
        const dateTime = `${date} ${time}`;
        const m = moment(dateTime, `${DATE_FORMAT} ${TIME_FORMAT}`);
        return m.isAfter(this.props.minStart);
    }

    handleDayClick(day) {
        const date = day.toISOString().slice(0, 10);
        const time = this.props.start_time;
        if (this.checkDateTimeValid(date, time)) {
            this.props.updateField('date', date);
        }
        if (this.props.calendarOnly) {
            this.props.toggleOptionCard();
        }
    }

    onStartChange(value) {
        const { date, dates, isMultiple } = this.props;
        let selectedDate = date;
        if (dates?.length > 0 && isMultiple) {
            [ selectedDate ] = dates.sort((a, b) => moment(a) - moment(b));  // earliest date
        }
        const time = value && value.format(TIME_FORMAT);
        if (this.checkDateTimeValid(selectedDate, time)) {
            this.props.updateField('start_time', time);
        }
    }

    onEndChange(value) {
        const end = value && value.format(TIME_FORMAT);
        let duration = moment
            .duration(end)
            .subtract(this.props.start_time, TIME_FORMAT)
            .as('hours');

        if (duration < 0 && duration >= -24) {
            duration += Number(24);
        }
        if (duration >= 1 && duration <= 16)
            this.props.updateField('duration', duration);
    }

    onMinutePickerOpen(value) {
        if (value.open) {
            setTimeout(() => {
                document
                    .querySelector('.rc-time-picker-panel')
                    .classList.add('minute-picker-panel');
            });
        }
    }

    handleDayMouseDown(day, modifiers) {
        if (modifiers.past || modifiers.outside) return;
        const isRemoving = !!modifiers.selected;
        this.props.updateField('rangeDatesSelected', [
            moment(day).format(DATE_FORMAT),
        ]);
        this.props.updateField('isRemoving', isRemoving);
        this.setState({
            mouseDown: true,
            fromDate: day,
        });
    }

    handleDayMouseUp() {
        if (this.props.isRemoving) {
            const dates = this.props.dates.filter(date => !this.props.rangeDatesSelected.includes(date));
            this.props.updateField('dates', dates);
        } else {
            const dates = [
                ...new Set([
                    ...this.props.dates,
                    ...this.props.rangeDatesSelected,
                ]),
            ];
            this.props.updateField('dates', dates);
        }
        this.props.updateField('rangeDatesSelected', []);
        this.setState({
            mouseDown: false,
            fromDate: null,
        });
    }

    toggleAllowMonthChange() {
        this.setState(
            prevState => ({
                ...prevState,
                allowMonthChange: false,
            }),
            () =>
                setTimeout(
                    () =>
                        this.setState(prevState =>({
                            ...prevState,
                            allowMonthChange: true,
                        })),
                    2000,
                ),
        );
    }

    handleDayMouseEnter(toDate, modifiers) {
        if (!this.state.mouseDown) return;

        if (modifiers.previousMonth && this.state.allowMonthChange) {
            this.daypickerRef.current.showPreviousMonth();
            this.toggleAllowMonthChange();
        } else if (modifiers.nextMonth && this.state.allowMonthChange) {
            this.daypickerRef.current.showNextMonth();
            this.toggleAllowMonthChange();
        }
        let dates = null;
        const { fromDate } = this.state;
        if (fromDate.toString() === toDate.toString()) {
            this.props.updateField('rangeDatesSelected', [
                moment(fromDate).format(DATE_FORMAT),
            ]);
            return;
        }
        if (moment(fromDate).isBefore(moment(toDate))) {
            const from = fromDate;
            const to = toDate;
            dates = dateArray.range(from, to, DATE_FORMAT, true);
        } else {
            const from = moment(toDate).isBefore(moment(this.props.minStart))
                ? moment(this.props.minStart).format(DATE_FORMAT)
                : toDate;
            const to = fromDate;
            dates = dateArray.range(from, to, DATE_FORMAT, true);
        }

        this.props.updateField('rangeDatesSelected', dates);
    }

    breaksHandler = e => {
        const value = e.target.value === '' ? null : Math.floor(e.target.value);
        this.props.updateField('breaks', value);
    };

    render() {
        const { isMultiple, mode, breaks } = this.props;
        let days = null;
        let modifiers = {
            past: {
                before: new Date(this.props.minStart),
            },
            nextMonth: day => {
                if (this.daypickerRef.current) {
                    return moment(day).isAfter(
                        moment(this.daypickerRef.current.state.currentMonth),
                        'month',
                    );
                }
                return null;
            },
            previousMonth: day => {
                if (this.daypickerRef.current) {
                    return moment(day).isBefore(
                        moment(this.daypickerRef.current.state.currentMonth),
                        'month',
                    );
                }
                return null;
            },
        };
        if (!this.props.isRemoving)
            days = this.props.dates.concat(this.props.rangeDatesSelected);
        else {
            days = this.props.dates.filter(
                date => !this.props.rangeDatesSelected.includes(date),
            );
        }
        const start_time =
            this.props.start_time == null
                ? getTime(this.props.minStart)
                : this.props.start_time;
        const startTime = moment(start_time, TIME_FORMAT);
        const endTime = moment(start_time, TIME_FORMAT).add(this.props.duration, 'h');
        let selectedDays;
        if (isMultiple) {
            selectedDays = day =>
                days.includes(moment(day).format(DATE_FORMAT));
            modifiers = {
                ...modifiers,
                'selected-right': day =>
                    days.includes(moment(day).add(1, 'd').format(DATE_FORMAT)),
                'selected-left': day =>
                    days.includes(
                        moment(day).add(-1, 'd').format(DATE_FORMAT),
                    ),
            };
        } else {
            selectedDays = moment(this.props.date, DATE_FORMAT).toDate();
        }

        const initialMonth = moment(this.props.queryDate).isValid()
            ? moment(this.props.queryDate, DATE_FORMAT).toDate()
            : new Date();

        return (
            <div className={`card card-role-timedate ${this.props.className}`}>
                <div className="card-content">
                    <div className="items-container">
                        <DayPicker
                            ref={this.daypickerRef}
                            weekdaysShort={['S', 'M', 'T', 'W', 'T', 'F', 'S']}
                            selectedDays={selectedDays}
                            initialMonth={initialMonth}
                            firstDayOfWeek={1}
                            fixedWeeks={true}
                            fromMonth={new Date(this.props.minStart)}
                            enableOutsideDays={true}
                            modifiers={modifiers}
                            onDayClick={!isMultiple ? this.handleDayClick : null}
                            onDayMouseDown={isMultiple ? this.handleDayMouseDown : null}
                            onDayMouseUp={isMultiple ? this.handleDayMouseUp : null}
                            onDayMouseEnter={isMultiple ? this.handleDayMouseEnter : null}
                            captionElement={({ date }) => (
                                <div className="DayPicker-Caption">
                                    {moment(date).format('MMMM')}
                                </div>
                            )}
                        />
                        <div className="role-time-picker">
                            <span>
                                From
                                <TimePicker
                                    format="HH"
                                    showSecond={false}
                                    showMinute={false}
                                    value={startTime}
                                    onChange={this.onStartChange}
                                />
                                <TimePicker
                                    format="mm"
                                    showSecond={false}
                                    showHour={false}
                                    value={startTime}
                                    onChange={this.onStartChange}
                                    onOpen={this.onMinutePickerOpen}
                                />
                            </span>
                            <span>
                                to
                                <TimePicker
                                    format="HH"
                                    showSecond={false}
                                    showMinute={false}
                                    value={endTime}
                                    onChange={this.onEndChange}
                                />
                                <TimePicker
                                    format="mm"
                                    showSecond={false}
                                    showHour={false}
                                    value={endTime}
                                    onChange={this.onEndChange}
                                    onOpen={this.onMinutePickerOpen}
                                />
                            </span>
                        </div>
                        <div className="role-breaks-container">
                            <label htmlFor="breaks">Break (in mins)</label>
                            <input
                                ref={this.breaksInput}
                                type="number"
                                value={breaks}
                                min={0}
                                onChange={this.breaksHandler}
                                id="breaks"
                                data-testid="breaksInput"
                            />
                        </div>
                        <div className="role-button-container">
                            {mode !== jobModes.EDIT &&
                                <RoleCardMultipleButton />
                            }
                        </div>
                        <NumberOfWorkersSpinner
                            number_of_freelancers={this.props.number_of_freelancers}
                            updateField={this.props.updateField}
                        />
                        {mode === jobModes.DUPLICATE &&
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: 20
                            }}>
                                <label>
                                    <input
                                        className="checkbox-purple"
                                        type="checkbox"
                                        style={{ margin: '5px' }}
                                        value={this.props.copyBookings}
                                        onChange={event =>
                                            this.props.changeCopyBookings(event.target.checked)}
                                    />
                                    Copy existing bookings
                                </label>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        rangeDatesSelected: state.requestData.bookingRequest.rangeDatesSelected,
        isMultiple: state.requestData.bookingRequest.isMultiple,
        start_time: state.requestData.bookingRequest.start_time,
        minStart: state.requestData.minStart,
        duration: state.requestData.bookingRequest.duration,
        isRemoving: state.requestData.bookingRequest.isRemoving,
        dates: state.requestData.bookingRequest.dates,
        date: state.requestData.bookingRequest.date,
        number_of_freelancers:
            state.requestData.bookingRequest.number_of_freelancers,
        breaks: state.requestData.bookingRequest.breaks,
    };
}

export default connect(mapStateToProps, {
    toggleOptionCard,
    updateField,
})(AgentTimeDateCard);
